import React from "react";

export const CalendarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7 2.25a.75.75 0 0 1 .75.75v1h4.5V3a.75.75 0 0 1 1.5 0v1h.75A2.5 2.5 0 0 1 17 6.5v8a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-8A2.5 2.5 0 0 1 5.5 4h.75V3a.75.75 0 0 1 .75-.75ZM4.5 9v5.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V9h-11Z"
      clipRule="evenodd"
    />
  </svg>
);
